import { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';

import { DataTransformEnums } from 'dashboard-services/api/dataTransform';

import { ExcelUtils } from 'utils';

import Row from '../Row';

const EMPTY_OBJ = {};

const CurveDatapointRow = ({ address = "", clearTable, formula, refreshCall, parsedParameters = EMPTY_OBJ }) => {
  const goToAddress = useCallback(() => ExcelUtils.goToAddress(address), [address]),
        localName = useMemo(() => `${parsedParameters?.groupName} ${parsedParameters?.product}`, [parsedParameters?.groupName, parsedParameters?.product]),
        readablePeriodTypeName = useMemo(() => DataTransformEnums.PERIOD_TYPE_ARRAY.find(pt => pt.value === parsedParameters?.periodType)?.label, [parsedParameters?.periodType])
        
  return (
    <Row
        address={address}
        formula={formula}
        name={localName}
        onClear={clearTable}
        onRefresh={refreshCall}
    >
      <div className="ng-office-app__authed__content__active-calls__row__cell ng-office-app__authed__content__active-calls__row__cell--group">
        <div className="ng-office-app__authed__content__active-calls__row__cell__top">
          Group:
        </div>
        <div className="ng-office-app__authed__content__active-calls__row__cell__bottom">
          {parsedParameters?.groupName ? parsedParameters?.groupName : "-"}
        </div>
      </div>
      <div className="ng-office-app__authed__content__active-calls__row__cell ng-office-app__authed__content__active-calls__row__cell--address">
        <div className="ng-office-app__authed__content__active-calls__row__cell__top">
          Cell reference:
        </div>
        <div
            className="ng-office-app__authed__content__active-calls__row__cell__bottom"
            onClick={goToAddress}
        >
          {address}
        </div>
      </div>
      <div className="ng-office-app__authed__content__active-calls__row__cell ng-office-app__authed__content__active-calls__row__cell--root">
        <div className="ng-office-app__authed__content__active-calls__row__cell__top">
          Root:
        </div>
        <div className="ng-office-app__authed__content__active-calls__row__cell__bottom">
          {parsedParameters?.root ? parsedParameters?.root : "-"}
        </div>
      </div>
      <div className="ng-office-app__authed__content__active-calls__row__cell ng-office-app__authed__content__active-calls__row__cell--columns">
        <div className="ng-office-app__authed__content__active-calls__row__cell__top">
          Column:
        </div>
        <div className="ng-office-app__authed__content__active-calls__row__cell__bottom">
          {parsedParameters?.column ? parsedParameters?.column : "-"}
        </div>
      </div>
      <div className="ng-office-app__authed__content__active-calls__row__cell ng-office-app__authed__content__active-calls__row__cell--date">
        <div className="ng-office-app__authed__content__active-calls__row__cell__top">
          Date:
        </div>
        <div className="ng-office-app__authed__content__active-calls__row__cell__bottom">
          {parsedParameters?.date ? parsedParameters?.date : "-"}
        </div>
      </div>
      <div className="ng-office-app__authed__content__active-calls__row__cell ng-office-app__authed__content__active-calls__row__cell--period-type">
        <div className="ng-office-app__authed__content__active-calls__row__cell__top">
          Period type:
        </div>
        <div className="ng-office-app__authed__content__active-calls__row__cell__bottom">
          {readablePeriodTypeName ? readablePeriodTypeName : "-"}
        </div>
      </div>
      <div className="ng-office-app__authed__content__active-calls__row__cell ng-office-app__authed__content__active-calls__row__cell--contract-type">
        <div className="ng-office-app__authed__content__active-calls__row__cell__top">
          Contract type:
        </div>
        <div className="ng-office-app__authed__content__active-calls__row__cell__bottom">
          {parsedParameters?.relative === "false" ? "Absolute" : "Relative"}
        </div>
      </div>
        <div className="ng-office-app__authed__content__active-calls__row__cell ng-office-app__authed__content__active-calls__row__cell--period">
        <div className="ng-office-app__authed__content__active-calls__row__cell__top">
          Period:
        </div>
        <div className="ng-office-app__authed__content__active-calls__row__cell__bottom">
          {parsedParameters?.period ? parsedParameters.period : "-"}
        </div>
      </div>
    </Row>
  )
}

CurveDatapointRow.propTypes = {
  address: PropTypes.string,
  clearTable: PropTypes.func.isRequired,
  formula: PropTypes.string.isRequired,
  parsedParameters: PropTypes.object,
  refreshCall: PropTypes.func.isRequired,
}

export default CurveDatapointRow;